"use client";

import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

interface TaskCardSkeletonProps {
  showSeparator?: boolean;
  fillContainer?: boolean;
}

export function TaskCardSkeleton({ showSeparator = true, fillContainer = false }: TaskCardSkeletonProps) {
  if (fillContainer) {
    return (
      <div
        className="task-card-skeleton-fill h-full overflow-hidden animate-pulse"
        aria-label="Cargando tareas"
      />
    );
  }

  return (
    <>
      <div className="p-4 border-l-4 border-l-gray-200">
        { }
        <div className="pb-3">
          <div className="flex justify-between items-start">
            { }
            <Skeleton className="h-6 w-48" />
            <div className="flex gap-2">
              { }
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
          </div>
          { }
          <Skeleton className="h-4 w-32 mt-1" />
          
          { }
          <div className="mt-2">
            <Skeleton className="h-6 w-24 rounded-md" />
          </div>
        </div>
        
        { }
        <div className="mb-3">
          <div className="grid grid-cols-2 gap-2">
            <div className="text-sm">
              <Skeleton className="h-4 w-20" />
            </div>
            <div className="text-sm">
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
        </div>
        
        { }
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4">
            { }
            <div className="flex items-center">
              <Skeleton className="h-4 w-4 mr-1" />
              <Skeleton className="h-4 w-20" />
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            { }
            <Skeleton className="h-8 w-24 rounded-md" />
          </div>
        </div>
      </div>
      
      {showSeparator && <Separator className="h-px bg-gray-200" />}
    </>
  );
}
